
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const bookingPlatforms = [
  {
    name: "Seaside Vacations",
    url: "https://www.outerbanksvacations.com/vacation-rentals/sdv306-beachbreak",
    bgColor: "bg-primary",
    hoverColor: "hover:bg-primary/90"
  },
  {
    name: "Airbnb",
    url: "https://www.airbnb.com/rooms/1184156151647820749",
    bgColor: "bg-[#FF385C]",
    hoverColor: "hover:bg-[#E31C5F]"
  },
  {
    name: "VRBO",
    url: "https://www.vrbo.com/4066372",
    bgColor: "bg-[#3B4DA3]",
    hoverColor: "hover:bg-[#2C3B8C]"
  }
];

const BookingForm = () => {
  return (
    <section className="py-16 px-4 bg-secondary/30">
      <div className="max-w-xl mx-auto">
        <Card className="fade-in">
          <CardHeader>
            <CardTitle className="text-3xl text-center">Book Your Stay</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {bookingPlatforms.map((platform) => (
              <Button
                key={platform.name}
                className={`w-full ${platform.bgColor} ${platform.hoverColor} transition-colors`}
                onClick={() => window.open(platform.url, "_blank")}
              >
                Book on {platform.name}
              </Button>
            ))}
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default BookingForm;
